import "core-js/modules/es.array.map";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.keys";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import utilRules from '@/libs/rules';
import { cloneDeep } from 'lodash';
var business = {
  name: '',
  position: '',
  phone: ''
};
var formData = {
  storeName: '',
  storeLogo: '',
  storeIntro: '',
  contactList: [cloneDeep(business)]
};

var rulelist = _toConsumableArray(Object.keys(formData).map(function (v) {
  return v;
}));

export default {
  data: function data() {
    return {
      formData: formData,
      rules: utilRules(rulelist)
    };
  },
  created: function created() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.getQiNiu();

              _context.next = 3;
              return _this.$api.information();

            case 3:
              _this.formData = _context.sent;

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    // 图片上传
    handleSuccess: function handleSuccess(response, key) {
      this.$set(this.formData, key, this.VUE_APP_IMG_BASE + response.key);
      this.$refs['loginForm'].clearValidate(key);
    },
    beforeUpload: function beforeUpload(file) {
      if (!YL.beforeUploadCommon(file, 'pic')) return false;
      this.uploadData.data.key = new Date().getTime() + YL.catchType(file.name);
    },
    addcontactList: function addcontactList() {
      this.formData.contactList.push(cloneDeep(business));
    },
    submit: function submit() {
      var _this2 = this;

      this.$refs.loginForm.validate( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(valid) {
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (valid) {
                    _context2.next = 2;
                    break;
                  }

                  return _context2.abrupt("return");

                case 2:
                  _context2.next = 4;
                  return _this2.$api.updateInformation(cloneDeep(_this2.formData));

                case 4:
                  YL.message('保存成功,请缴纳保证金');
                  YL.isStoreAuto(3);

                case 6:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }
};